module.exports = __webpack_public_path__ + "static/media/discover.f04a5b8f.jpg";